import { ElementRef, Injectable } from '@angular/core';
import { PreviewDispatchService } from './services/preview-dispatch.service';
import { Section } from '../editor-container/editor-model';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root'
})
export class PreviewReceiptionService {
  private htmlOpenString = "<div class='preview-selected' style='box-sizing:border-box;position:absolute;top:0;left:0;width:100%;height:100%;'>";
  private htmlInnerString = "<div>&nbsp;</div>";
  private htmlEndString = "</div>";

  //"<div class='preview-selected'style='border:2px solid #0a0a8b;box-sizing:border-box;position:absolute;top:0;left:0;width:100%;height:100%;background:blue;opacity:0.1;'>&nbsp;</div>"
  constructor(private dispatcher:PreviewDispatchService) { }
  /**
   * 
   * @param parentEl The top HTMLElement containing the element to select
   * @param targetEl This id attribute for the element to be selected
   */
  selectElement(parentEl:HTMLElement,targetEl:string){
    console.log({parentEl:parentEl,targetRl:targetEl});
    //Clean up previously selected section highlighter
    let selectCandidates = parentEl.querySelectorAll(".preview-selected");
    if(selectCandidates != undefined){
      selectCandidates.forEach((candidate:HTMLElement) => {
        if(!candidate.classList.contains("hide-selector")){
          candidate.classList.add("hide-selector");
        }
      })
    }
    //console.log("Selecting Elements");
    //console.log(parentEl);
    //console.log(`Track selected El : ${parentEl} ${targetEl}`)
    //this.removeSelection(parentEl);
    //let targetElId = targetEl.getAttribute("id");
    //let selectedEl = <HTMLElement>parentEl.querySelector('#'+targetEl);
    let selectedEl = <HTMLElement>parentEl.querySelector('[id="'+targetEl+'"]');
    console.log(selectedEl);
    if(selectedEl != undefined && selectedEl != null){
      //Get the wrapper class
      console.log("Found Selected Element");

      const wrapperEl = <HTMLElement>selectedEl.querySelector('.wrapper');
      if(wrapperEl != undefined){
        wrapperEl.style.setProperty("position","relative");
        //wrapperEl.style.setProperty("border","2px solid #0a0a8b");
        const height = wrapperEl.offsetHeight;
        const width = wrapperEl.offsetWidth;
        let selectEl = wrapperEl.querySelector(".preview-selected");
        selectEl.classList.toggle('hide-selector');
        //Get first child
        //const siblingChild = <HTMLElement>wrapperEl.firstElementChild;
        //siblingChild.insertAdjacentHTML("afterend",this.htmlOpenString+this.htmlInnerString+this.htmlEndString);
        /* console.log(parentEl.offsetTop);
        selectedEl.scrollTop = parentEl.offsetTop;
        selectedEl.scrollTo({
          top: parentEl.offsetTop,
          behavior: 'smooth',
        }) */
       /*  setTimeout(() => {
          selectedEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          })
        }, 0); */
        /* selectedEl.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        }) */
        /* parentEl.scrollTo({
          top: selectedEl.offsetTop,
          behavior: 'smooth',
        }) */
        //wrapperEl.style.setProperty("position","relative");

      }
      this.dispatcher.setEditElement(selectedEl)
    }else{
      console.error("cannot find element with id: "+targetEl)
    }
  }

  downloadSectionImage(parentRef:ElementRef,targetEl:Element|string){
    let fakeA = document.createElement('a')//parentRef.nativeElement.appendChild;
    let selectedEl:HTMLElement;
    if(typeof targetEl === "string"){
      selectedEl = parentRef.nativeElement;      
    }else{
      selectedEl = <HTMLElement>parentRef.nativeElement.querySelector('#'+targetEl);
    }
    if(selectedEl != undefined && selectedEl != null){
      html2canvas(selectedEl,{allowTaint:true,useCORS: true}).then((canvas) => {
        fakeA.href = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')
        fakeA.download = 'testshit.jpg'
        fakeA.click()
/*         cellObj["classList"] = selectedCell.classList;
        cellObj["imgSrc"] = canvas.toDataURL(); */
        //cellLayoutOptions.push({class:_layoutClass,imgSrc:canvas.toDataURL()});
        //console.log(imageData);
      });
    }
    fakeA.remove();
  }

  removeSelection(parentEl:HTMLElement){
    const currentSelection = <HTMLElement>parentEl.querySelector('.preview-selected');
    if(currentSelection != undefined){
      //currentSelection.style.setProperty("border","");
      currentSelection.remove()
    }
  }

  deleteElement(parentEl:HTMLElement,targetEl:Element){
    const selectedEl = <HTMLElement>parentEl.querySelector('#'+targetEl);
    if(selectedEl != undefined){
      selectedEl.style.setProperty("display","none");
    }
  }

  hideElement(el:HTMLElement,targetEl:Element){
    const selectedEl = <HTMLElement>el.querySelector('#'+targetEl);
    if(selectedEl != undefined){
      selectedEl.style.setProperty("display","none");
    }
  }

  showElement(el:HTMLElement,targetEl:Element){
    const selectedEl = <HTMLElement>el.querySelector('#'+targetEl);
    if(selectedEl != undefined){
      selectedEl.style.setProperty("display","block");
    }
  }
  editSelect(el:HTMLElement,targetEl:Element){

  }

  getCellJson(el:HTMLElement,targetEl:string,cellId:string):any{
    const selectedEl = <HTMLElement>el.querySelector('#'+targetEl);
    let cellObj = {};
    if(selectedEl != undefined){
      let selectedCells = selectedEl.querySelectorAll('[cell-id="'+cellId+'"]')
      if(selectedCells != undefined){
        let selectedCell = <HTMLElement>selectedCells[0];
        if(selectedCell != undefined){
          html2canvas(selectedCell,{allowTaint:true,useCORS: true}).then((canvas) => {
            cellObj["classList"] = selectedCell.classList;
            cellObj["imgSrc"] = canvas.toDataURL();
            //cellLayoutOptions.push({class:_layoutClass,imgSrc:canvas.toDataURL()});
            //console.log(imageData);
          });
        }
      }
      return cellObj
      //const cells = selectedEl.getElementsByClassName("grid-cell-container");
    }
  }

  getCellLayoutThumbs(el:HTMLElement,targetEl:string,section:Section,cellId:string):any[]{
    let cellLayoutOptions:any[];
    let selectedCell:HTMLElement = null;
    //console.log({el:el,targetEl:targetEl,section:section,cellId:cellId})
    const selectedEl = <HTMLElement>el.querySelector('#'+targetEl);
    if(selectedEl != undefined){
      const cells = selectedEl.getElementsByClassName("grid-cell-container");
      if(cells != undefined){
        for(let i = 0; i < cells.length; i++){
            let cell = <HTMLElement>cells[i];
            if(cell.getAttribute("cell-id") != undefined && cell.getAttribute("cell-id") == cellId){
              console.log("Found the cell")
              selectedCell = cell;
              cellLayoutOptions = this.getLayoutOptions(selectedCell,section)
              break;
            }else{
              console.log("ant find cell for: "+cell.getAttribute("cell-id"))
            }          
        }
      }else{
        console.log("Cant find cells")
      }

    }
    /* setTimeout(function(){ 
      return imageData;
   }, 1000); */
   //console.log(cellLayoutOptions);
   return cellLayoutOptions;
    //const selectedEl = <HTMLElement>el.querySelector('#'+targetEl);
  }

  getLayoutOptions(selectedCell:HTMLElement,section:Section):any[]{
    let cellLayoutOptions:any[] = [];
    let layoutClasses:string[];
    if(section.rendererType == "testimonials" || section.rendererType == "banner"){
      let selectedClass:string = null;
      if(section.rendererType == "testimonials"){
        layoutClasses = section.sectionData["testimonialOptions"].cellLayoutClasses
      }else if(section.rendererType == "banner"){
        layoutClasses = section.sectionData["bannerOptions"].cellLayoutClasses;
      }
      if(layoutClasses != undefined){
        layoutClasses.forEach(layoutClass => {
          if(selectedCell.classList.contains(layoutClass)){
            selectedCell.classList.remove(layoutClass)
          }
        })
        layoutClasses.forEach(_layoutClass => {
          selectedCell.classList.add(_layoutClass);
          html2canvas(selectedCell,{allowTaint:true,useCORS: true}).then((canvas) => {
            cellLayoutOptions.push({class:_layoutClass,imgSrc:canvas.toDataURL()});
            //console.log(imageData);
          });
          selectedCell.classList.remove(_layoutClass);
        })
      }
    }
    //console.log(cellLayoutOptions)
    return cellLayoutOptions;
  }

}
